export default "__VITE_ASSET__Bmv2zsN8__"